import { Component, OnInit } from '@angular/core';
import { TrackingTimelineResponse } from 'src/app/model/trackingTimelineResponse.model';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  parcelInformations: TrackingTimelineResponse;
  errorMessage: string ="";
  informationsMessage: [];
  color: string;

  constructor() { }

  ngOnInit(): void {
    var parcelDataReceived = history.state.parcelInformations;
    if (parcelDataReceived) {
      this.parcelInformations = parcelDataReceived;
      this.errorMessage =  parcelDataReceived.status[0].message;
      this.informationsMessage = parcelDataReceived.message;
    }
  }

}
